import ReactDOM from "react-dom/client";
import { ToastContainer } from "react-toastify";

import App from "./App";
import { Contexts } from "./contexts";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
	document.getElementById("root")!
);
root.render(
	<>
		<ToastContainer />
		<Contexts>
			<App />
		</Contexts>
	</>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
